module.exports = __webpack_public_path__ + "static/media/gold_reserve_desktop.93b27fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/backgrounds/gold_reserve_desktop.jpg
// module id = 527
// module chunks = 0